<template>
  <div>
    <h1 class="mb-5">Form Şablon Listesi</h1>
    <v-card>
      <v-tabs>
        <v-tab>Hazır Şablonlar</v-tab>

        <v-tab-item
          transition="fade-transition"
          reverse-transition="fade-transition"
        >
          <FormTemplateList />
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module';

export default {
  name: 'formTemplates',
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Form Şablon Listesi', route: '/form-sablonlari' },
    ]);
  },
  components: {
    FormTemplateList: () => import('@/components/forms/TemplateList'),
  },
};
</script>
